import { memo, type ReactNode } from 'react';

import type { PageWidths } from 'pkg/config/sizes';

import type * as models from 'pkg/api/models';
import type { Features } from 'pkg/api/models/group';
import type { MiddlewareFn } from 'pkg/router/middlewares';

import type { SymbolVariant } from 'components/material-symbols';

import type { SubNavItemProps } from 'components/layout/page-templates';

export interface RouteProps {
	after?: MiddlewareFn[];
	before?: MiddlewareFn[];
	component?: unknown;

	name?: string;

	path: string;

	wrapWith?: unknown;
	/**
	 * The router keys a route's page by its name, so moving to another route
	 * mounts a new page. Routes that share a mount key share one page
	 * instead: it stays mounted as they change, and the route's component
	 * gets the new route's props. The routes need the same `wrapWith` and
	 * `component` for anything inside to stay mounted. The router's
	 * `wrapAllWith` providers stay mounted with it, keeping their state.
	 */
	mountKey?: string;
	redirectTo?: string;
	feature?: Features;
	userInformationNotRequired?: boolean;
	/**
	 * Set if the route shouldn't appear in Mixpanel analytics.
	 */
	skipAnalytics?: boolean;
	backgroundColor?: string;
	icon?: SymbolVariant;
	title?: string;
	organization?: models.group.Group;
	subNavItems?: SubNavItemProps[];
	currentTab?: string;
	matchCurrentTab?: string;
	compactHeader?: boolean;
	maxWidth?: PageWidths;
	noContentPadding?: boolean;
	children?: ReactNode;
	showHeader?: boolean;
	keyByTab?: boolean;
	/**
	 * Forwarded to `FullScreenWorkspacePage`: pass `false` on routes that render
	 * their own footer in-flow so the mobile shell drops its reserved action-bar
	 * strip (which would otherwise show the blue page background).
	 */
	hasMobileActionBar?: boolean;
}

export const Route = memo<RouteProps>(() => null);
